import { render, staticRenderFns } from "./SellOrBuyAnalyze.vue?vue&type=template&id=7460b702&scoped=true&"
import script from "./SellOrBuyAnalyze.vue?vue&type=script&lang=js&"
export * from "./SellOrBuyAnalyze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460b702",
  null
  
)

export default component.exports